import { Component, Prop } from 'vue-property-decorator'
import Wizard from '@src/pages/wizard/wizard'
import { API } from '@src/lib/api_path'
import Checkup from '@src/data/checkup'
import camelcaseKeys from 'camelcase-keys'
import { MemberProfile } from '@src/data/member-profile'

type MemberResponse = { profile: MemberProfile }
type CheckupResponse = { checkup: Checkup }

@Component({
  computed: {
    checkup () {
      return this.$store.state.checkup
    },
    steps () {
      return this.$store.state.checkup.getSteps({ omitNotes: true, omitFinish: true }) || []
    }
  }
})
export default class MemberReadonlyWizard extends Wizard {

  @Prop({ required: false, default: true })
  protected isReadonly: boolean

  constructor () {
    super()
  }

  protected loadMember () {
    return this.apiClient.get<MemberResponse>(API.MEMBERS_API.PROFILE)
      .then((response: MemberResponse) => this.$store.dispatch('setSelectedMember', new MemberProfile(camelcaseKeys(response.profile))))
      .catch(error => console.error('failed to retrieve member', error))
      .finally(() => this.loadingMember = false)
  }

  protected loadCheckup () {
    if (this.$route.params.checkupId) {
      return this.apiClient.get<CheckupResponse>(`${API.MEMBERS_API.CHECKUPS.replace('{memberId}', this.$route.params.id)}/${this.$route.params.checkupId}`)
        .then((response) => {
          let checkup = new Checkup(camelcaseKeys(response.checkup))
          if (this.basePath.includes('onboarding')) {
            checkup.startOnboarding()
          }
          this.$store.dispatch('setCheckup', checkup)
          this.goToStep(this.step || this.startStep)
        })
        .catch(err => console.error('Failed to retrieve checkup ', err))
        .finally(() => this.loading = false)

    } else {
      this.goToStep(this.step || this.startStep)
      this.loading = false
    }
  }
}
